import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoSettingsOutline } from "react-icons/io5";
import { IoCheckmarkSharp } from "react-icons/io5";
import { FaPlus } from "react-icons/fa";
import axios from "axios";

import { useSubscriptionContext } from "../hooks/useSubscriptionContext";
import { useAuthContext } from "../hooks/useAuthContext";
import { useTranslation } from "react-i18next";

const LoboCard = ({ name, description, active, icon, subscribe }) => {
  const { t } = useTranslation();

  const { user } = useAuthContext();
  const clubDetailsString = localStorage.getItem("club_details");
  const club_details = JSON.parse(clubDetailsString);
  const navigate = useNavigate();
  const { subscriptions, loading } = useSubscriptionContext();
  const [authStatus, setAuthStatus] = useState(false);
  const [error, setError] = useState("");
  const [playtomicNotConfigured, setPlaytomicNotConfigured] = useState(false);

  // const isSubscribed =
  // subscribe == "lobo_match"
  // ? subscriptions?.[subscribe] === 1 || subscriptions?.["lobo_lite"] === 1
  // : subscriptions?.[subscribe] === 1;

  const isSubscribed = subscriptions?.[subscribe] === 1;

  const handleConfigClick = () => {
    navigate(`config/${name.toLowerCase()}`);
  };

  const handleSubscribeClick = () => {
    navigate(`/sr-lobo-store`);
  };

  useEffect(() => {
    getAuthStatus();
    if (subscribe === "lobo_match") {
      checkPlaytomicConfig();
    }
  }, []);

  const getAuthStatus = async () => {
    try {
      const response = await axios.get(
        `/api/whatsapp/getAuthStatus/${club_details?.club_id}`,
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );
      if (response.status === 200) {
        setAuthStatus(true);
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        console.log(error.response.data.error);
        // logout();
      } else {
        setError("Ocurrió un error al obtener los datos");
      }
    }
  };

  const checkPlaytomicConfig = async () => {
    const integratedSystem = club_details?.integrated_system;
    if (integratedSystem !== "syltek" && integratedSystem !== "playtomic") {
      return;
    }

    try {
      const [credentialsRes, clientCredentialsRes] = await Promise.all([
        axios.get(
          `/api/wcb/playtomic-credentials?clubId=${club_details?.club_id}`,
          { headers: { Authorization: `Bearer ${user?.token}` } }
        ),
        axios.get(
          `/api/wcb/playtomic-client-credentials?clubId=${club_details?.club_id}`,
          { headers: { Authorization: `Bearer ${user?.token}` } }
        ),
      ]);

      const { playtomic_email, playtomic_password } = credentialsRes.data;
      const { playtomic_client_id, playtomic_client_secret } =
        clientCredentialsRes.data;

      setPlaytomicNotConfigured(
        !playtomic_email ||
          !playtomic_password ||
          !playtomic_client_id ||
          !playtomic_client_secret
      );
    } catch (error) {
      setPlaytomicNotConfigured(true);
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div
      className={`w-full rounded-md border bg-secondary mb-4 text-primary border-primary`}
    >
      <div className="flex justify-between px-2 py-2">
        <div className="flex justify-center items-center gap-2 mx-2 my-2">
          <div className="w-[50px] h-[50px] rounded-md bg-black border border-primary text-primary flex justify-center items-center">
            {icon}
          </div>
          <div className="mx-2 font-semibold">{name}</div>
        </div>
        <div className="h-max flex flex-row items-center gap-2">
          {subscribe == "lobo_match" ? (
            isSubscribed == true ? (
              !authStatus ? (
                <span className="text-red-500">
                  {t("WhatsAppisnotconnected")}
                </span>
              ) : (
                <span className="text-primary">{t("WhatsAppconnected")}</span>
              )
            ) : null
          ) : null}
          <div
            className={`w-[12px] h-[12px] rounded-full ${
              isSubscribed == true
                ? subscribe == "lobo_match"
                  ? !authStatus
                    ? "bg-red-500"
                    : "bg-primary"
                  : "bg-primary"
                : "bg-slate-400"
            }`}
          ></div>
        </div>
      </div>
      <p className="px-4 text-sm mb-4 text-white">{description}</p>
      {subscribe === "lobo_match" && playtomicNotConfigured && (
        <p className="px-4 text-sm mb-4 text-red-500">
          {t("PlaytomicCredentialsNotConfigured")}
        </p>
      )}
      <div className="flex justify-between items-baseline">
        {/* <button
          className="mx-4 mb-4 text-sm px-2 py-2 rounded-md flex justify-center items-center gap-1 border border-black"
          onClick={handleConfigClick}
        >
          <IoSettingsOutline />
          configurar
        </button> */}
        <div className="relative group mx-4 mb-4">
          <button
            className={`text-sm px-2 py-2 rounded-md flex justify-center items-center gap-1 border ${
              isSubscribed
                ? "border-white text-white"
                : "border-gray-300 text-gray-400 "
            }`}
            onClick={handleConfigClick}
            disabled={!isSubscribed}
          >
            <IoSettingsOutline />
            {t("setup")}
          </button>

          {!isSubscribed && (
            <span className="absolute -top-10 left-1/2 bg-gray-800 text-white text-xs px-3 py-2 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-nowrap">
              {t("Pleasesubscribeto")} {name} {t("toconfigure")}
            </span>
          )}
        </div>
        <div className="mx-6">
          {isSubscribed === true ? (
            <p className="text-primary text-sm flex justify-center items-center font-semibold">
              <IoCheckmarkSharp />
              {t("Active")}
            </p>
          ) : (
            <button
              className="text-xs flex px-4 py-3 rounded-md justify-center items-center gap-1 bg-primary text-secondary"
              onClick={handleSubscribeClick}
            >
              <FaPlus />
              {t("hire")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoboCard;
